import { Link } from "react-router-dom";
import styled from "styled-components";

export const OverriddenLink = styled(Link)`
  color: ${props =>
    props.$isActive
      ? "var(--link-color-primary-600-color,var(--color-primary-600))"
      : "var(--mode-text-neutral-default-weak)"};
  text-decoration: none;
  width: 100%;
  display: inline-block;

  &:hover {
    color: var(--link-color-primary-600-color, var(--color-primary-600));
  }
`;
